/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Actions/NavigationActionsHub" />
import { Action, ActionsHubBase } from "DistributedTask/Flux/Actions";


export class NavigationActionsHub extends ActionsHubBase {
    initialize(_?: string): void {
        const scope = "NAVIGATION_SCOPE";

        this._navigateBack = new Action<void>(scope);
        this._closePanel = new Action<void>(scope);
    }

    public static getKey(): string {
        return "endpoint-navigation-actions";
    }

    public get setNavigateBack(): Action<void> {
        return this._navigateBack;
    }

    public get setClosePanel(): Action<void> {
        return this._closePanel;
    }

    private _navigateBack: Action<void>;
    private _closePanel: Action<void>;
}
